/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "react-responsive-pagination";
import {
  currency,
  formatDateDash,
  ITEM_PER_PAGE,
  messageError,
  messageSuccess,
  userStatus,
  setParams,
  getCurrency,
} from "../../helper";

import "./app.scss";
import { DELETE_USER, QUERY_USER } from "./apollo";
import EditMember from "./editUser";
import Notiflix from "notiflix";
import PreviewImage from "../../helper/previewImage";
import AddUser from "./adduser";
import LimitData from "../../controllers/LimitData";
import { useLazyQuery, useMutation } from "@apollo/client/react";

export default function ListUsers() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location?.search);
  const [currentPage, setCurrentPage] = useState(1);
  const [numberRows, setNumberRows] = useState(ITEM_PER_PAGE);
  const [newLoadData, setNewLoadData] = useState(false);

  const [userList, setDataUser] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [deleteUser] = useMutation(DELETE_USER);
  const [fetchUser, { data: userData }] = useLazyQuery(QUERY_USER, {
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    fetchUser({
      variables: {
        where: {
          fullSearch: searchValue ? String(searchValue) : undefined,
        },
        skip: numberRows * currentPage - numberRows,
        limit: numberRows,
      },
    });
  }, [newLoadData, currentPage, numberRows, fetchUser, searchValue]);

  useEffect(() => {
    setDataUser(userData?.users?.data);
  }, [userData]);

  const totalItem = userData?.users?.total;
  const totalPage = Math.ceil(totalItem / numberRows);

  const NO = (index) => {
    const no = numberRows * currentPage - numberRows;
    if (numberRows > 0) {
      return no + index + 1;
    } else {
      return index + 1;
    }
  };

  const _onChangeRows = (e) => {
    let _value = e?.target?.value;
    navigate({
      search: setParams(`rows`, _value),
    });
    setNumberRows(parseInt(_value));
  };

  useEffect(() => {
    let page = queryParams.get("page");
    let rows = queryParams.get("rows");

    if (page) {
      setCurrentPage(parseInt(page));
    } else {
      setCurrentPage(1);
    }
    if (rows) {
      setNumberRows(parseInt(rows));
    } else {
      setNumberRows(ITEM_PER_PAGE);
    }
  }, [queryParams]);

  //ລົບຂໍ້ມູນ
  const _handleDelete = (id) => {
    Notiflix.Confirm.show(
      "ແຈ້ງເຕືອນ",
      "ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ນີ້ແທ້ ຫຼື ບໍ່?",
      "ຕົກລົງ",
      "ຍົກເລີກ",
      async () => {
        try {
          const _delete = await deleteUser({
            variables: {
              where: {
                id: parseInt(id),
              },
            },
          });
          if (_delete) {
            messageSuccess("ດຳເນີນການສຳເລັດ");
            setNewLoadData(!newLoadData);
          }
        } catch (error) {
          console.log(error);
          messageError("ດຳເນີນການບໍ່ສຳເລັດ");
        }
      },
      () => {
        return false;
      }
    );
  };

  return (
    <>
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="row">
          <div className="col-md-12" style={{ zIndex: 1 }}>
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <p className="mb-md-0 mb-2 d-flex align-items-center gap-2">
                    <AddUser
                      setNewLoad={(res) => setNewLoadData(!newLoadData)}
                    />
                  </p>
                  <div className="d-flex align-items-center flex-wrap">
                    <LimitData
                      numberRows={numberRows}
                      onChangeRows={_onChangeRows}
                      onSearch={(_onSearch) => {
                        setSearchValue(_onSearch);
                      }}
                      numberPage={currentPage}
                      total={totalItem}
                      hiddenSearch={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div id="cart" className="iq-product-tracker-card show b-0">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-responsive mb-0 table-sm rounded">
                        <thead>
                          <tr>
                            <th width={10}>ລຳດັບ</th>
                            <th className="text-nowrap">ຊື່ ແລະ ນາມສະກຸນ</th>
                            <th className="text-nowrap">ຊື່ຫຼີ້ນ</th>
                            <th className="text-nowrap text-center">ເບີໂທ</th>
                            <th className="text-nowrap">ອີເມວ</th>
                            <th className="text-nowrap">ວັນທີສະໝັກ</th>
                            <th className="text-nowrap">ສະຖານະ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userList?.map((item, index) => (
                            <>
                              <tr item-item="list" key={index}>
                                <td className="text-center">{NO(index)}</td>
                                <td scope="row" className="text-nowrap">
                                  <div className="d-flex align-items-center gap-4">
                                    <PreviewImage
                                      image={item?.profileImagePath}
                                      width={100}
                                      height={100}
                                    />
                                    <div>
                                      <b className="fs-4 text-primary align-top">
                                        {item?.firstName
                                          ? item?.firstName
                                          : "-"}{" "}
                                        {item?.lastName ? item?.lastName : " "}
                                      </b>
                                      <br />
                                      <span className="text-muted">
                                        <i className="icon-clock me-1" />{" "}
                                        {item?.createdAt
                                          ? formatDateDash(item?.createdAt)
                                          : "-"}
                                      </span>
                                      <br />
                                      <span className="text-muted">
                                        <i className="icon-person_add me-1" />{" "}
                                        {item?.role ? item?.role : "-"}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>{item?.username ? item?.username : " "}</td>
                                <td>
                                  {item?.phoneNumber ? item?.phoneNumber : " "}
                                </td>
                                <td>{item?.email ? item?.email : " "}</td>
                                <td className="text-center">
                                  {formatDateDash(
                                    item?.createdAt ? item?.createdAt : " "
                                  )}
                                </td>
                                <td>
                                  <EditMember
                                    item={item}
                                    onSuccess={() => {
                                      setNewLoadData(!newLoadData);
                                    }}
                                  />
                                  <button
                                    className="btn btn-icon  btn-danger rounded-circle"
                                    onClick={(e) => {
                                      _handleDelete(item?.id);
                                    }}
                                  >
                                    <i className="icon-trash fs-5" />
                                  </button>
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer">
                      {(() => {
                        return (
                          <Pagination
                            total={totalPage}
                            current={currentPage || 1}
                            onPageChange={(page) => {
                              navigate({
                                search: setParams("page", page.toString()),
                              });
                              setNumberRows(parseInt(page));
                            }}
                          />
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
